/**
 * Client id for the Segment OAuth app the source connector authorizes against.
 *
 * Three apps rather than the usual two: standalone has its own, separate from the
 * one production and production-like staging share. A client id is public — it
 * travels in the authorization URL — so these live in the bundle like the other
 * OAuth app ids here.
 */

/** Development and devbox. https://app.segment.com/developer/apps/1641/info/basic */
const DEVELOPMENT_CLIENT_ID = 'a03d57fd-91e0-460c-a3f5-915439bf7419';

/** Standalone only. */
const STANDALONE_CLIENT_ID = 'fa49d532-5eaf-499c-8445-d13894a444f9';

/** Production and production-like staging. https://app.segment.com/developer/apps/1640/info/basic */
const PRODUCTION_CLIENT_ID = '8d15b66e-40c4-4222-8b2f-f4c095e6630c';

export function getSegmentOAuthClientId(): string {
  if (__CIO_ENV__ === 'standalone') return STANDALONE_CLIENT_ID;

  if (__CIO_ENV__ === 'production' || __CIO_ENV__ === 'prod-staging-1' || __CIO_ENV__ === 'prod-staging-2') {
    return PRODUCTION_CLIENT_ID;
  }

  return DEVELOPMENT_CLIENT_ID;
}
